import * as Config from '../../../../../config';

const useCustomGenres = (track, isEnabled) => {

  let storeDD = JSON.parse(localStorage.getItem('dd'));
  if (!storeDD) {
    storeDD = [];
    localStorage.setItem('dd', JSON.stringify(storeDD))
  }

  //Best New Independent Artist
  const categories = ['Independent Artist', 'Best New Hype', 'Best New', /*'Best Of Hype', 'Best Of',*/ 'Shortlist', /*'Warm Up Essentials',*/ 'Dancefloor Essentials', 'Closing Essentials', 'After Hour Essentials', 'Crate Diggers', 'Secret Weapons'];
  const formatTitle = (x) => {
    let lock = false;
    x.name = categories.reduce((base,cat) => {
      if (x.name.toLowerCase().includes(cat.toLowerCase()) && !lock) {
        base = cat;
        lock = true;
      }
      return base;
    }, x.name)
    return x;
  }

  // %26
  // const orderOpenFormat = [
  //   {id: 102, order: [864240, 864242, 864225, 864230, 864232, 864235, 864231, 864233, 864238, 864239, 864224]},
  //   {id: 103, order: [864201, 864223, 864222, 864212, 864211, 864209, 864210, 864213, 864214, 864215]},
  //   {id: 105, order: [864205, 864204, 864206, 864208, 864219, 864249, 864248, 864247, 864246, 864221, 864245, 864226, 864243, 864228, 864220]},
  //   {id: 106, order: [864182, 864199, 864197, 864179, 864180, 864186, 864183, 864181, 864191, 864187, 864184, 864192, 864194, 864195, 864188, 864196]},
  //   {id: 107, order: [864160, 864168, 864167, 864165, 864164, 864169, 864147, 864171, 864158, 864163, 864156, 864161]},
  //   {id: 108, order: [864250, 864263, 864257, 864254, 864252, 864251, 864253, 864262, 864261, 864264, 864255, 864260, 864258, 864259, 864265]},
  // ];
  const playlistsNameOpenFormat = [
    {id: 102, names: ['Fresh Afrobeats', '2020s Afrobeats Hits', 'African Essentials', 'Afropop: Must Have Hits', 'Amapiano Infused', 'Opening Afrobeats', 'Prime Time Afrobeats', 'Afro Bashment', 'African Crossovers', 'Afro-R&B', 'Clean Afrobeats Party', 'Closing Afrobeats', 'Clean Caribbean Party', '80s Dancehall', 'Sunshine Reggae', 'Trap Dancehall', 'Closing Caribbean', '2010s Caribbean Hits', '2020s Caribbean Hits']},
    {id: 103, names: ['Fresh Caribbean', '2020s Caribbean Hits', '2010s Caribbean Hits', '90s Dancehall', '80s Dancehall', 'Clean Caribbean Party', 'Caribbean Essentials', 'Sunshine Reggae', 'Trap Dancehall', 'Closing Caribbean', 'Essential Caribbean']},
    {id: 105, names: ['Fresh Hip-Hop', '2020s Hip-Hop', 'Clean Hip-Hop Party', '90s Hip-Hop Hits', '2000s Hip-Hop Hits', '2010s Hip-Hop Hits', 'Hip-Hop Party Starters', 'Opening Hip-Hop', 'Prime Time Hip-Hop', 'Rap Essentials', '90s West Coast Classics', '2010s West Coast Classics', '2000s East Coast Classics', '2000s Southern Hip-Hop', '2000s Midwest Classics', '80s Hip-Hop Hits', 'Essential Hip-Hop']},
    {id: 106, names: ['Fresh Latin', '2020s Latin Hits', '2010s Latin Hits', 'Clean Latin Party', 'Latin Essentials', 'Opening Latin', 'Prime Time Latin', 'Reggaeton Classico', 'Reggaeton', 'Dembow', 'Salsa', 'Latin Crossovers', 'Cumbia', 'Merengue', 'Bachata', `Vibras Pal' Verano`, '100% Karol G', 'Essential Latin', 'Latin Afrobeats']},
    {id: 107, names: ['Fresh Pop', '2020s Pop Hits', '2010s Pop Hits', '2000s Pop Hits', '90s Pop Hits', 'Pop Essentials', 'Clean Pop Party', 'Classic Party Bangers', 'All-Ages Party', '80s Pop Hits', '2000s Party', '70s Pop Hits', '100% Justin Bieber', 'Essential Pop']},
    {id: 108, names: ['Fresh R&B', '2020s R&B Hits', '2010s R&B Hits', '2000s R&B Hits', '90s R&B Hits', 'Disco Soul Classics', 'Clean R&B Party', 'Cookout Classics', 'Motown', 'Funk', 'New Jack Swing', 'R&B Essentials', '90s R&B Slow Jams', '80s R&B Hits', '70s R&B Hits', 'Rollerskating Disco Classics', 'Essential R&B']},
    {id: 104, names: ['Fresh Country', 'Country Essentials', 'Pop Country', 'Backyard Country BBQ', 'YEEDM & Country Dance', '2010s Country', '2000s Country', '90s Country', '70s & 80s Country', 'Country Line Dances', 'Essential Country']},
    {id: 109, names: ['Fresh Rock', '2010s Rock', '2000s Rock', '90s Rock', '80s Rock', '70s Rock', '60s Rock', '50s Rock', 'Yacht Rock', 'Emo Rock & Pop Punk', 'Clean Rock Party', '80s New Wave', '2020s Rock', 'Essential Rock', 'Metal Party']},
  ];
  const getPlaylistsOpenFormatByID = (id) => {
    const item = playlistsNameOpenFormat.find( x => x.id === id );
    return (item) ? item.names : [];
  }

  const getMainGenre = (genres, slug) => {
    let max = 0;
    return genres.reduce((base, g, i) => {
      let words = g.slug.split('-');
      const extra = Config.GENRES_CUSTOM_EXTRA_SEARCH_SLUG.find( e => e.id === g.id );
      if (extra && extra.words) {
        words = [...words, ...extra.words];
      }
      let count = 0;
      words.forEach( word => { count += (slug.includes(word)) ? 1 : 0 })
      if ((count > max) || (count === words.length && count >= max)) {
        max = count;
        return g;
      } else {
        return base;
      }
    }, null);
  }

  const isUpdated = (name, dateUpdated) => {
    const item = storeDD.find( x => x.n === name );
    if (!item) { // Initialization when visible and no existing
      storeDD.push({n: name, u: dateUpdated});
      localStorage.setItem('dd', JSON.stringify(storeDD))
    }
    return (item && item.u !== dateUpdated)
  }

  return { formatTitle, getMainGenre, isUpdated, getPlaylistsOpenFormatByID };
};

export default useCustomGenres;
